module.exports = __webpack_public_path__ + "static/fimap@2x.4d7003fd.png";